import React, { useState, useEffect, useCallback } from "react";
import { useUserContext } from "../../utils/UserContext";
import { mapToPresentable, mapejos } from "../../utils/Mapejos";
import { formatAddress, formatDate } from "../../utils/Utilitats";
import AjudaEntitats from "./AjudaEntitats";
import { BotoAjuda } from "./AjudaModal";
import TeclaEscEnter from "../../utils/Teclaescenter";
import { API_URL } from "../../utils/config";
import { fetchAutenticat, SessioCaducadaError } from "../../utils/auth";
import { tincPermis } from "../../utils/Permisos";
import { resumHorariText } from "./HorariEditor";
import "../dashboard_v2.css";
import "./detallsempleat.css";

function mateixId(a, b) {
  if (a == null || b == null || a === "") return false;
  return Number(a) === Number(b);
}

function DetallsEmpleat({
  mode,
  empleat,
  empleats,
  onNavigate,
  onSave,
  onCancel,
  onDeleted,
  onCanviarMode,
  subnav,
}) {
  const isReadOnly = mode === "consultar" || mode === "esborrar";

  // UserContext
  const { empresaSeleccionada, rolUsuari } = useUserContext();
  const pucModificar = tincPermis(rolUsuari, "MODIFICAR");
  const pucEsborrarFitxa = tincPermis(rolUsuari, "ESBORRAR");
  const pucGestio = tincPermis(rolUsuari, "ACCES", "EMPLEATS");
  const [menuAccions, setMenuAccions] = useState(false);
  const [mostraAjuda, setMostraAjuda] = useState(false);
  const potGestionarHorari = tincPermis(rolUsuari, "ACCES", "GESTIO_LABORAL");

  TeclaEscEnter(onCancel, null);

  const avui = new Date().toISOString().split("T")[0]; // Obté la data actual en forma

  // Estats per a tots els camps
  const [tipusEntitat, setTipusEntitat] = useState("Particular");
  const [nom, setNom] = useState("");
  const [cognom1, setCognom1] = useState("");
  const [cognom2, setCognom2] = useState("");
  const [nomComercial, setNomComercial] = useState("");
  const [cifDni, setCifDni] = useState("");
  const [tipusVia, setTipusVia] = useState("");
  const [nomVia, setNomVia] = useState("");
  const [numVia, setNumVia] = useState("");
  const [escalaVia, setEscalaVia] = useState("");
  const [pis, setPis] = useState("");
  const [porta, setPorta] = useState("");
  const [poblacio, setPoblacio] = useState("");
  const [provincia, setProvincia] = useState("");
  const [pais, setPais] = useState("");
  const [codiPostal, setCodiPostal] = useState("");
  const [referencies, setReferencies] = useState("");
  const [telefon, setTelefon] = useState("");
  const [mobil1, setMobil1] = useState("");
  const [mobil2, setMobil2] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [paginaWeb, setPaginaWeb] = useState("");
  const [email1, setEmail1] = useState("");
  const [email2, setEmail2] = useState("");
  const [compteBancari, setCompteBancari] = useState("");
  const [actiu, setActiu] = useState(true);
  const [activitat, setActivitat] = useState(true);
  const [professio, setProfessio] = useState(null);
  const [professioDescripcio, setProfessioDescripcio] = useState("");
  const [dataAlta, setDataAlta] = useState(avui);
  const [dataBaixa, setDataBaixa] = useState("");
  const [categoria, setCategoria] = useState(null);
  const [dataCanviCategoria, setDataCanviCategoria] = useState("");
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const [professionsOptions, setProfessionsOptions] = useState([]);
  const [filteredOptionsProfessions, setFilteredOptionsProfessions] = useState([]);
  const [showDropdownProfessions, setShowDropdownProfessions] = useState(false);
  const [categoriaInicial, setCategoriaInicial] = useState(null);
  const [categoriaHaCanviat, setCategoriaHaCanviat] = useState(false);

  // Usuari associat (relació opcional 0..1 <-> 0..1 amb Usuaris)
  const [usuariAssignat, setUsuariAssignat] = useState(null);
  const [usuarisDisponibles, setUsuarisDisponibles] = useState([]);

  // Política de control horari (Empleats.ControlHorari)
  const [controlHorari, setControlHorari] = useState("OBLIGATORI");

  // Resum en text pla de l'Horari vigent, només calculat en mode
  // consultar/esborrar (isReadOnly). null = encara carregant.
  const [horariResum, setHorariResum] = useState(null);
  const [horariResumError, setHorariResumError] = useState(false);


  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [description, setDescription] = useState("");
  const [isModification, setIsModification] = useState("");
  const [newDescription, setNewDescription] = useState("");


  const fetchCategories = async () => {
    try {
      const response = await fetch(`${API_URL}/Tipusmaobra.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idEmpresa: empresaSeleccionada?.IdEmpresa }),
      });

      const data = await response.json();
      if (data.success) {
        setCategoriesOptions(data.tipusMaObra);
      } else {
        console.error("Error carregant categories:", data.message);
      }
    } catch (error) {
      console.error("Error carregant categories:", error);
    }
  };

const fetchTipusProfessions = async () => {
    try {
    const response = await fetch(`${API_URL}/Tipusprofessions.php`);
    const data = await response.json();
    if (data.success) {
        setProfessionsOptions(data.data);
    } else {
        console.error("Error carregant Professions:", data.message);
    }
    } catch (error) {
    console.error("Error carregant Professions:", error);
    }
};

  // Reset del formulari per a "Nou"
  const resetForm = useCallback(() => {
    setTipusEntitat("Particular");
    setNom("");
    setCognom1("");
    setCognom2("");
    setNomComercial("");
    setCifDni("");
    setTipusVia("");
    setNomVia("");
    setNumVia("");
    setEscalaVia("");
    setPis("");
    setPorta("");
    setPoblacio("");
    setProvincia("");
    setPais("");
    setCodiPostal("");
    setReferencies("");
    setTelefon("");
    setMobil1("");
    setMobil2("");
    setWhatsapp("");
    setPaginaWeb("");
    setEmail1("");
    setEmail2("");
    setCompteBancari("");
    setActiu(true);
    setActivitat(true);
    setProfessio(null);
    setProfessioDescripcio("");
    setDataAlta(avui);
    setDataBaixa("");
    setCategoria(null);
    setCategoriaInicial(null);
    setDataCanviCategoria("");
    setUsuariAssignat(null);
    setControlHorari("OBLIGATORI");
  }, []);

  // Carrega els Usuaris de l'Empresa que es poden assignar (actius i no
  // assignats a cap altre Empleat). Es torna a demanar quan canvia
  // l'Empleat, perquè cal excloure'n l'assignació actual.
  const fetchUsuarisDisponibles = useCallback(async () => {
    if (!empresaSeleccionada?.IdEmpresa) return;
    try {
      const response = await fetchAutenticat(`${API_URL}/UsuarisDisponiblesEmpleat.php`, {
        method: "POST",
        body: JSON.stringify({
          idEmpresa: empresaSeleccionada.IdEmpresa,
          idEmpleatActual: empleat?.idEmpleats || null,
        }),
      });
      const data = await response.json();
      if (data.success) {
        setUsuarisDisponibles(data.usuaris);
      }
    } catch (error) {
      if (!(error instanceof SessioCaducadaError)) {
        console.error("Error carregant usuaris disponibles:", error);
      }
    }
  }, [empresaSeleccionada, empleat]);

  useEffect(() => {
    if (mode !== "esborrar") {
      fetchUsuarisDisponibles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode, empresaSeleccionada, empleat?.idEmpleats]);

  const validacioEmpleat = (empleatData) => {
    const { Entitats, Adreces, Empleats } = empleatData;
    const errors = [];

    // Entitats
    if (!Entitats.TipusEntitat) {
      errors.push("L'organització és obligatòria.");
    }
    if (!Entitats.Nom?.trim()) {
      errors.push("El camp Nom és obligatori.");
    }

    if (!Entitats.Cognom1?.trim()) {
      errors.push("El 1r Cognom és obligatori per Particulars o Autònoms.");
    }

    // Adreces
    if (!Adreces.TipusVia?.trim()) {
      errors.push("El Tipus de Via és obligatori.");
    }
    if (!Adreces.NomVia?.trim()) {
      errors.push("El Nom de la Via és obligatori.");
    }
    if (!Adreces.NumVia?.trim()) {
      errors.push("El Número de la Via és obligatori.");
    }
    if (!Adreces.Poblacio?.trim()) {
      errors.push("El camp Població és obligatori.");
    }
    if (!Adreces.Provincia?.trim()) {
      errors.push("El camp Província és obligatori.");
    }
    if (!Adreces.Pais?.trim()) {
      errors.push("El camp País és obligatori.");
    }
    if (!Adreces.CodiPostal?.trim()) {
      errors.push("El camp Codi Postal és obligatori.");
    }

    if (!Empleats.IdTipusMaObra) {
        errors.push("La categoria és obligatòria.");
      }
  

    // Professió (no obligatòria, però si es posa cal validar-la)
    if (
      Entitats.Professions_idProfessions &&
      !professionsOptions.some(
        (option) => option.idProfessions === Entitats.Professions_idProfessions
      )
    ) {
      errors.push("La Professió seleccionada no existeix.");
    }

    if (Empleats.Actiu && Empleats.DataBaixa?.trim()) {
      errors.push("Un empleat actiu no pot tenir una Data de Baixa.");
    }
  

    return errors;
  };


  const empleatModificat = (empleatOriginal, empleatData) => {
    const updatedEmpleat = {
      ...empleatOriginal,
      TipusEntitat: empleatData.Entitats.TipusEntitat,
      Nom: empleatData.Entitats.Nom,
      Cognom1: empleatData.Entitats.Cognom1,
      Cognom2: empleatData.Entitats.Cognom2,
      NomComercial: empleatData.Entitats.NomComercial,
      CIF_DNI: empleatData.Entitats.CIF_DNI,
      TelefonFixe: empleatData.Entitats.Telefon,
      TelefonMobil: empleatData.Entitats.TelefonMobil,
      TelefonMobil2: empleatData.Entitats.TelefonMobil2,
      Whatsapp: empleatData.Entitats.Whatsapp,
      PaginaWeb: empleatData.Entitats.PaginaWeb,
      Email1: empleatData.Entitats.Email1,
      Email2: empleatData.Entitats.Email2,
      CompteBancari: empleatData.Entitats.CompteBancari,
      Activitat: empleatData.Entitats.Activitat,
      Professions_idProfessions: empleatData.Entitats.Professions_idProfessions,
      Usuaris_idUsuaris: empleatData.Empleats.Usuaris_idUsuaris,
      ControlHorari: empleatData.Empleats.ControlHorari,
      TipusVia: empleatData.Adreces.TipusVia,
      NomVia: empleatData.Adreces.NomVia,
      NumVia: empleatData.Adreces.NumVia,
      EscalaVia: empleatData.Adreces.EscalaVia,
      Pis: empleatData.Adreces.Pis,
      Porta: empleatData.Adreces.Porta,
      Poblacio: empleatData.Adreces.Poblacio,
      Provincia: empleatData.Adreces.Provincia,
      Pais: empleatData.Adreces.Pais,
      CodiPostal: empleatData.Adreces.CodiPostal,
      Referencies: empleatData.Adreces.Referencies,
      idTipusMaObra: empleatData.Empleats.IdTipusMaObra,
    };

    // Descripció de Professió
   if (updatedEmpleat.Professions_idProfessions) {
      updatedEmpleat.Professio =
        professionsOptions.find(
          (option) => option.idProfessions === updatedEmpleat.Professions_idProfessions
        )?.Descripcio || empleatOriginal.Professio;
    }

     // Descripció de Categoria
     if (updatedEmpleat.idTipusMaObra) {
      updatedEmpleat.Categoria =
          categoriesOptions.find(
              (option) => option.idTipusMaObra === updatedEmpleat.idTipusMaObra
          )?.Tipus || empleatOriginal.Categoria;
     }

    return updatedEmpleat;
  };


  const handleSubmit = async () => {
    const empleatData = {
        idEmpleats: empleat?.idEmpleats || null,
        Entitats: {
          IdEntitats: empleat?.Entitats_idEntitats || null,
          TipusEntitat: tipusEntitat,
          Nom: nom,
          Cognom1: cognom1,
          Cognom2: cognom2,
          NomComercial: nomComercial,
          CIF_DNI: cifDni,
          Telefon: telefon,
          TelefonMobil: mobil1,
          TelefonMobil2: mobil2,
          Whatsapp: whatsapp,
          PaginaWeb: paginaWeb,
          Email1: email1,
          Email2: email2,
          CompteBancari: compteBancari,
          Activitat: actiu,
          Professions_idProfessions: professio,
        },
        Adreces: {
          TipusVia: tipusVia,
          NomVia: nomVia,
          NumVia: numVia,
          EscalaVia: escalaVia,
          Pis: pis,
          Porta: porta,
          Poblacio: poblacio,
          Provincia: provincia,
          Pais: pais,
          CodiPostal: codiPostal,
          Referencies: referencies,
        },
        Empleats: {
          Actiu: actiu,
          DataAlta: dataAlta,
          DataBaixa: dataBaixa,
          IdTipusMaObra: categoria,
          DataCanviCategoria: categoriaHaCanviat ? dataCanviCategoria : null,
          Usuaris_idUsuaris: usuariAssignat || null,
          ControlHorari: controlHorari,
        },
        Empresa_Empleats: {
          Empresa_IdEmpresa: empresaSeleccionada?.IdEmpresa || null,
        },
      };

      console.log("Dades a enviar del empleat:", empleatData);

      const errors = validacioEmpleat(empleatData);
      if (errors.length > 0) {
       alert(`Errors trobats:\n${errors.join("\n")}`);
       return;
      }

    try {
        if (mode === "nou") {
            const response = await fetchAutenticat(`${API_URL}/Nouempleat.php`, {
            method: "POST",
            body: JSON.stringify(empleatData),
            });
            const data = await response.json();
            if (data.success) {
            alert("Empleat creat correctament!");
            onSave?.(null);
            } else {
            alert(`Error en crear l'empleat: ${data.message}`);
            }
        } else if (mode === "modificar") {
            empleatData.idEmpleats = empleat.idEmpleats;
            
            const response = await fetchAutenticat(`${API_URL}/Modificarempleat.php`, {
            method: "POST",
            body: JSON.stringify(empleatData),
            });
            const data = await response.json();
            if (data.success) {
            alert("Empleat modificat correctament!");
            const updatedEmpleat = empleatModificat(empleat, empleatData);
            onSave(updatedEmpleat);
            } else {
            alert(`Error en modificar l'empleat: ${data.message}`);
            }
        } else if (mode === "esborrar") {
            setShowDeleteModal(true);
        }
        } catch (error) {
        if (!(error instanceof SessioCaducadaError)) {
          console.error("Error en l'operació de l'empleat:", error);
          alert("S'ha produït un error en el procés.");
        }
        }
    };

      const handleSaveModal = async () => {
        const nomProfessio = newDescription.trim();
        if (!nomProfessio) {
          alert("La descripció no pot estar buida.");
          return;
        }
        try {
          if (isModification) {
            const response = await fetch(`${API_URL}/ModificaProfessions.php`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id: professio,
                newDescription: nomProfessio,
              }),
            });
            const data = await response.json();
            if (data.success) {
              fetchTipusProfessions();
              setProfessioDescripcio(nomProfessio);
              setShowModal(false);
            } else {
              alert(`Error modificant la professió: ${data.message}`);
            }
          } else {
            const response = await fetch(`${API_URL}/AltaProfessions.php`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ description: nomProfessio }),
            });
            const data = await response.json();
            if (data.success) {
              fetchTipusProfessions();
              const Idretornat = parseInt(data.id, 10);
              if (mode !== "nou" && empleat) {
                empleat.Professions_idProfessions = Idretornat;
              }
              setProfessio(Idretornat);
              setProfessioDescripcio(nomProfessio);
              setShowModal(false);
            } else {
              alert(`Error creant la professió: ${data.message}`);
            }
          }
        } catch (error) {
          console.error("Error al gestionar el modal:", error);
          alert("Hi ha hagut un error. Torna-ho a intentar.");
        }
      };

      


  useEffect(() => {
    fetchTipusProfessions();    
}, []);


  // Carrega les opcions de TipusMaObra (categories)
  useEffect(() => {
    fetchCategories();
  }, [empresaSeleccionada]);

  useEffect(() => {
    if (empleat && categoriesOptions.length > 0) {
      const categoriaSeleccionada = categoriesOptions.find(
        (option) => option.idTipusMaObra === empleat.idTipusMaObra
      );
      if (categoriaSeleccionada) {
        setCategoria(categoriaSeleccionada.idTipusMaObra);
      }
    }
  }, [empleat, categoriesOptions, mode]);

    useEffect(() => {
      if (empleat?.Professions_idProfessions && professionsOptions.length > 0) {
        const professioOption = professionsOptions.find(
          (option) => option.idProfessions === empleat.Professions_idProfessions
        );
        setProfessioDescripcio(professioOption?.Descripcio || "");
      }
    }, [empleat?.Professions_idProfessions, professionsOptions]);
  
  
    // Actualitzem desplegables
    useEffect(() => {
      setFilteredOptionsProfessions(professionsOptions);
    }, [professionsOptions]);


  // Carreguem dades de l'empleat si és consulta o modificació
  useEffect(() => {
    if (empleat) {
      setNom(empleat.Nom || "");
      setCognom1(empleat.Cognom1 || "");
      setCognom2(empleat.Cognom2 || "");
      setCifDni(empleat.CIF_DNI || "");
      setTipusVia(empleat.TipusVia || "");
      setNomVia(empleat.NomVia || "");
      setNumVia(empleat.NumVia || "");
      setEscalaVia(empleat.EscalaVia || "");
      setPis(empleat.Pis || "");
      setPorta(empleat.Porta || "");
      setPoblacio(empleat.Poblacio || "");
      setProvincia(empleat.Provincia || "");
      setPais(empleat.Pais || "");
      setCodiPostal(empleat.CodiPostal || "");
      setReferencies(empleat.Referencies || "");
      setTelefon(empleat.Telefon || "");
      setMobil1(empleat.TelefonMobil || "");
      setMobil2(empleat.TelefonMobil2 || "");
      setWhatsapp(empleat.Whatsapp || "");
      setPaginaWeb(empleat.PaginaWeb || "");
      setEmail1(empleat.Email1 || "");
      setEmail2(empleat.Email2 || "");
      setCompteBancari(empleat.CompteBancari || "");
      setActivitat(empleat.Activitat ?? true);
      setActiu(empleat.Actiu ?? true);
      setProfessio(empleat.Professions_idProfessions || null);
      setDataAlta(empleat.DataAlta || "");
      setDataBaixa(empleat.DataBaixa || "");
      setProfessioDescripcio(empleat.Professio || "");
      setCategoria((prevCategoria) => prevCategoria || empleat.idTipusMaObra || null);
      setUsuariAssignat(empleat.Usuaris_idUsuaris || null);
      setControlHorari(empleat.ControlHorari || "OBLIGATORI");
    } else {
      resetForm();  
    }
  }, [empleat, mode, resetForm]);

  // Resum en text pla de l'Horari vigent (només en mode consultar/esborrar,
  // i només si es té permís de Gestió laboral per accedir a l'endpoint).
  useEffect(() => {
    if (!isReadOnly || !potGestionarHorari || !empleat?.idEmpleats || !empresaSeleccionada?.IdEmpresa) {
      setHorariResum(null);
      setHorariResumError(false);
      return;
    }

    let actiu = true;
    setHorariResum(null);
    setHorariResumError(false);

    (async () => {
      try {
        const response = await fetchAutenticat(
          `${API_URL}/EmpleatHorariActual.php?idEmpleat=${empleat.idEmpleats}&idEmpresa=${empresaSeleccionada.IdEmpresa}`
        );
        const data = await response.json();
        if (!actiu) return;
        if (data.success) {
          setHorariResum(resumHorariText(data.horari));
        } else {
          setHorariResumError(true);
          setHorariResum([]);
        }
      } catch (error) {
        if (!actiu) return;
        if (!(error instanceof SessioCaducadaError)) {
          console.error("Error carregant el resum de l'Horari:", error);
          setHorariResumError(true);
          setHorariResum([]);
        }
      }
    })();

    return () => {
      actiu = false;
    };
  }, [isReadOnly, potGestionarHorari, empleat?.idEmpleats, empresaSeleccionada?.IdEmpresa]);

  useEffect(() => {
    if (empleat && empleat.idTipusMaObra) {
      setCategoriaInicial(empleat.idTipusMaObra); // Categoria original
    }
  }, [empleat]);



  // ====== Navegació (fletxes) en CONSULTAR ======
  const currentIndex = empleats
    ? empleats.findIndex((e) => mateixId(e.idEmpleats, empleat?.idEmpleats))
    : -1;

  const anteriorEmpleat = () => {
    if (!empleats || empleats.length === 0 || currentIndex < 0) return;
    const newIndex = currentIndex === 0 ? empleats.length - 1 : currentIndex - 1;
    onNavigate?.(empleats[newIndex]);
  };

  const seguentEmpleat = () => {
    if (!empleats || empleats.length === 0 || currentIndex < 0) return;
    const newIndex = currentIndex === empleats.length - 1 ? 0 : currentIndex + 1;
    onNavigate?.(empleats[newIndex]);
  };

  // Nom de l'Usuari associat a mostrar en text (Consultar/Esborrar). Primer
  // mirem la llista de "disponibles" (dona el Rol i si és inactiu), i si no
  // hi és (p.ex. encara no s'ha carregat), caiem al camp que ja ve calculat
  // des del backend a la llista d'Empleats.
  const nomUsuariAssignatText = () => {
    if (!usuariAssignat) return "Sense usuari";
    const trobat = usuarisDisponibles.find((u) => u.idUsuaris === usuariAssignat);
    if (trobat) {
      return `${trobat.NomUsuari}${trobat.NomRol ? ` (${trobat.NomRol})` : ""}${trobat.Actiu ? "" : " (inactiu)"}`;
    }
    if (empleat?.NomUsuariAssignat) {
      return `${empleat.NomUsuariAssignat}${empleat.UsuariAssignatActiu ? "" : " (inactiu)"}`;
    }
    return "—";
  };

  const camp = (label, required, content, mida = "mig") => {
    const extra =
      mida === "ample" || mida === "wide"
        ? "dv2-field--ample"
        : mida === "llarg" || mida === "long"
        ? "dv2-field--llarg"
        : mida === "curt"
        ? "dv2-field--curt"
        : "dv2-field--mig";
    return (
      <label className={`dv2-field ${extra}`}>
        <span className={`dv2-label ${required && !isReadOnly ? "dv2-required" : ""}`}>{label}</span>
        {content}
      </label>
    );
  };

  const renderProfessio = () => {
    if (isReadOnly) return <span className="dv2-value">{professioDescripcio || "—"}</span>;
    return (
      <div className="dv2-controlRow">
        <select
          className="dv2-select"
          value={professio != null ? String(professio) : ""}
          onChange={(e) => {
            const id = e.target.value ? Number(e.target.value) : null;
            const op = professionsOptions.find((o) => mateixId(o.idProfessions, id));
            setProfessio(id);
            setProfessioDescripcio(op?.Descripcio || "");
          }}
        >
          <option value="">— Sense professió —</option>
          {professionsOptions.map((o) => (
            <option key={o.idProfessions} value={String(o.idProfessions)}>
              {o.Descripcio}
            </option>
          ))}
        </select>
        <button
          type="button"
          className="dv2-btn dv2-btn--compact"
          onClick={() => {
            setIsModification(false);
            setDescription("");
            setNewDescription("");
            setShowModal(true);
          }}
        >
          + Nova
        </button>
        {professio ? (
          <button
            type="button"
            className="dv2-btn dv2-btn--ghost dv2-btn--compact"
            onClick={() => {
              setIsModification(true);
              setDescription(professioDescripcio || "");
              setNewDescription(professioDescripcio || "");
              setShowModal(true);
            }}
          >
            Canvia nom
          </button>
        ) : null}
      </div>
    );
  };

  const renderCamps = () => {
    const adreca = {
      TipusVia: tipusVia,
      NomVia: nomVia,
      NumVia: numVia,
      EscalaVia: escalaVia,
      Pis: pis,
      Porta: porta,
      Poblacio: poblacio,
      CodiPostal: codiPostal,
    };
    const categoriaNom =
      categoriesOptions.find((o) => mateixId(o.idTipusMaObra, categoria))?.Tipus || empleat?.Categoria || "—";

    return (
      <>
        <section className="dv2-card">
          <div className="dv2-card-head">
            <span className="dv2-card-num">1</span>
            <h2 className="dv2-card-title">Identificació</h2>
          </div>
          <div className="dv2-fields dv2-fields--sizes">
            {camp(
              "Nom",
              true,
              isReadOnly ? (
                <span className="dv2-value">{nom || "—"}</span>
              ) : (
                <input type="text" className="dv2-input" value={nom} maxLength={100} onChange={(e) => setNom(e.target.value)} />
              ),
              "llarg"
            )}
            {camp(
              "1r cognom",
              true,
              isReadOnly ? (
                <span className="dv2-value">{cognom1 || "—"}</span>
              ) : (
                <input type="text" className="dv2-input" value={cognom1} onChange={(e) => setCognom1(e.target.value)} />
              )
            )}
            {camp(
              "2n cognom",
              false,
              isReadOnly ? (
                <span className="dv2-value">{cognom2 || "—"}</span>
              ) : (
                <input type="text" className="dv2-input" value={cognom2} onChange={(e) => setCognom2(e.target.value)} />
              )
            )}
            {camp(
              "DNI",
              false,
              isReadOnly ? (
                <span className="dv2-value">{cifDni || "—"}</span>
              ) : (
                <input type="text" className="dv2-input" value={cifDni} maxLength={12} onChange={(e) => setCifDni(e.target.value)} />
              )
            )}
          </div>
        </section>

        <section className="dv2-card">
          <div className="dv2-card-head">
            <span className="dv2-card-num">2</span>
            <h2 className="dv2-card-title">Adreça</h2>
          </div>
          {isReadOnly ? (
            <div className="dv2-fields dv2-fields--sizes">
              {camp("Adreça", false, <span className="dv2-value">{formatAddress(adreca) || "—"}</span>, "ample")}
              {camp("Referències", false, <span className="dv2-value">{referencies || "Sense referències."}</span>, "ample")}
            </div>
          ) : (
            <div className="dv2-fields dv2-fields--sizes">
              {camp(
                "Tipus de via",
                true,
                <select className="dv2-select" value={tipusVia} onChange={(e) => setTipusVia(e.target.value)}>
                  <option value="">Selecciona</option>
                  {Object.keys(mapejos.tipusVia).map((option) => (
                    <option key={option} value={option}>
                      {mapToPresentable(option, mapejos.tipusVia)}
                    </option>
                  ))}
                </select>
              )}
              {camp(
                "Nom de la via",
                true,
                <input type="text" className="dv2-input" value={nomVia} maxLength={100} onChange={(e) => setNomVia(e.target.value)} />,
                "llarg"
              )}
              {camp(
                "Número",
                true,
                <input type="text" className="dv2-input" value={numVia} maxLength={15} onChange={(e) => setNumVia(e.target.value)} />,
                "curt"
              )}
              {camp(
                "Escala",
                false,
                <input type="text" className="dv2-input" value={escalaVia} maxLength={10} onChange={(e) => setEscalaVia(e.target.value)} />,
                "curt"
              )}
              {camp(
                "Pis",
                false,
                <input type="text" className="dv2-input" value={pis} maxLength={25} onChange={(e) => setPis(e.target.value)} />,
                "curt"
              )}
              {camp(
                "Porta",
                false,
                <input type="text" className="dv2-input" value={porta} maxLength={5} onChange={(e) => setPorta(e.target.value)} />,
                "curt"
              )}
              {camp(
                "Població",
                true,
                <input type="text" className="dv2-input" value={poblacio} maxLength={100} onChange={(e) => setPoblacio(e.target.value)} />
              )}
              {camp(
                "Província",
                true,
                <input type="text" className="dv2-input" value={provincia} maxLength={50} onChange={(e) => setProvincia(e.target.value)} />
              )}
              {camp(
                "País",
                true,
                <input type="text" className="dv2-input" value={pais} maxLength={100} onChange={(e) => setPais(e.target.value)} />
              )}
              {camp(
                "Codi postal",
                true,
                <input type="text" className="dv2-input" value={codiPostal} maxLength={10} onChange={(e) => setCodiPostal(e.target.value)} />,
                "curt"
              )}
              {camp(
                "Referències",
                false,
                <textarea className="dv2-textarea" value={referencies} maxLength={256} onChange={(e) => setReferencies(e.target.value)} />,
                "ample"
              )}
            </div>
          )}
        </section>

        <section className="dv2-card">
          <div className="dv2-card-head">
            <span className="dv2-card-num">3</span>
            <h2 className="dv2-card-title">Contacte</h2>
          </div>
          <div className="dv2-fields dv2-fields--sizes">
            {camp(
              "Telèfon fixe",
              false,
              isReadOnly ? (
                <span className="dv2-value">{telefon || "—"}</span>
              ) : (
                <input type="text" className="dv2-input" value={telefon} maxLength={20} onChange={(e) => setTelefon(e.target.value)} />
              )
            )}
            {camp(
              "Mòbil 1",
              false,
              isReadOnly ? (
                <span className="dv2-value">{mobil1 || "—"}</span>
              ) : (
                <input type="text" className="dv2-input" value={mobil1} maxLength={20} onChange={(e) => setMobil1(e.target.value)} />
              )
            )}
            {camp(
              "Whatsapp",
              false,
              isReadOnly ? (
                <span className="dv2-value">{whatsapp || "—"}</span>
              ) : (
                <input type="text" className="dv2-input" value={whatsapp} maxLength={20} onChange={(e) => setWhatsapp(e.target.value)} />
              )
            )}
            {camp(
              "Mòbil 2",
              false,
              isReadOnly ? (
                <span className="dv2-value">{mobil2 || "—"}</span>
              ) : (
                <input type="text" className="dv2-input" value={mobil2} maxLength={20} onChange={(e) => setMobil2(e.target.value)} />
              )
            )}
            {camp(
              "E-mail 1",
              false,
              isReadOnly ? (
                <span className="dv2-value">{email1 || "—"}</span>
              ) : (
                <input type="email" className="dv2-input" value={email1} maxLength={45} onChange={(e) => setEmail1(e.target.value)} />
              ),
              "llarg"
            )}
            {camp(
              "E-mail 2",
              false,
              isReadOnly ? (
                <span className="dv2-value">{email2 || "—"}</span>
              ) : (
                <input type="email" className="dv2-input" value={email2} maxLength={45} onChange={(e) => setEmail2(e.target.value)} />
              ),
              "llarg"
            )}
            {camp(
              "Pàgina web",
              false,
              isReadOnly ? (
                <span className="dv2-value">{paginaWeb || "—"}</span>
              ) : (
                <input type="text" className="dv2-input" value={paginaWeb} maxLength={100} onChange={(e) => setPaginaWeb(e.target.value)} />
              ),
              "llarg"
            )}
          </div>
        </section>

        <section className="dv2-card">
          <div className="dv2-card-head">
            <span className="dv2-card-num">4</span>
            <h2 className="dv2-card-title">Laboral</h2>
          </div>
          <div className="dv2-fields dv2-fields--sizes">
            {camp(
              "Categoria",
              true,
              isReadOnly ? (
                <span className="dv2-value">{categoriaNom}</span>
              ) : (
                <select
                  className="dv2-select"
                  value={categoria ?? ""}
                  onChange={(e) => {
                    const novaCategoria = e.target.value ? parseInt(e.target.value, 10) : null;
                    const haCanviat = novaCategoria !== categoriaInicial;
                    if (haCanviat) {
                      setCategoriaHaCanviat(true);
                      setCategoria(novaCategoria);
                      if (!dataCanviCategoria) setDataCanviCategoria(avui);
                    } else {
                      setDataCanviCategoria("");
                      setCategoriaHaCanviat(false);
                      setCategoria(novaCategoria);
                    }
                  }}
                >
                  <option value="">Selecciona</option>
                  {categoriesOptions.map((option) => (
                    <option key={option.idTipusMaObra} value={option.idTipusMaObra}>
                      {option.Tipus}
                    </option>
                  ))}
                </select>
              ),
              "llarg"
            )}
            {!isReadOnly && categoriaHaCanviat && mode !== "nou" &&
              camp(
                "Data de canvi",
                false,
                <input type="date" className="dv2-input" value={dataCanviCategoria} onChange={(e) => setDataCanviCategoria(e.target.value)} />,
                "curt"
              )}
            {camp("Professió", false, renderProfessio(), "llarg")}
            {camp(
              "Compte bancari",
              false,
              isReadOnly ? (
                <span className="dv2-value">{compteBancari || "—"}</span>
              ) : (
                <input type="text" className="dv2-input" value={compteBancari} maxLength={34} onChange={(e) => setCompteBancari(e.target.value)} />
              ),
              "llarg"
            )}
            {camp(
              "Usuari associat",
              false,
              isReadOnly ? (
                <span className="dv2-value">{nomUsuariAssignatText()}</span>
              ) : (
                <select
                  className="dv2-select"
                  value={usuariAssignat ?? ""}
                  onChange={(e) => setUsuariAssignat(e.target.value ? parseInt(e.target.value, 10) : null)}
                >
                  <option value="">Sense usuari</option>
                  {usuarisDisponibles.map((u) => (
                    <option key={u.idUsuaris} value={u.idUsuaris}>
                      {u.NomUsuari} {u.NomRol ? `(${u.NomRol})` : ""}
                      {u.Actiu ? "" : " (inactiu)"}
                    </option>
                  ))}
                </select>
              ),
              "llarg"
            )}
            {camp(
              "Control horari",
              false,
              isReadOnly ? (
                <span className="dv2-value">{mapToPresentable(controlHorari, mapejos.controlHorari) || "—"}</span>
              ) : (
                <select className="dv2-select" value={controlHorari} onChange={(e) => setControlHorari(e.target.value)}>
                  {Object.keys(mapejos.controlHorari).map((option) => (
                    <option key={option} value={option}>
                      {mapToPresentable(option, mapejos.controlHorari)}
                    </option>
                  ))}
                </select>
              )
            )}
            {camp(
              "Actiu",
              false,
              isReadOnly ? (
                <span className="dv2-value">{actiu ? "Sí" : "No"}</span>
              ) : (
                <span className="dv2-toggleRow">
                  <span className="dv2-toggle">
                    <input type="checkbox" checked={!!actiu} onChange={(e) => setActiu(e.target.checked)} />
                    <span className="dv2-toggle-track" />
                  </span>
                </span>
              ),
              "curt"
            )}
            {camp(
              "Data d'alta",
              false,
              isReadOnly ? (
                <span className="dv2-value">{formatDate(dataAlta)}</span>
              ) : (
                <input type="date" className="dv2-input" value={dataAlta} onChange={(e) => setDataAlta(e.target.value)} />
              ),
              "curt"
            )}
            {mode !== "nou" &&
              camp(
                "Data de baixa",
                false,
                isReadOnly ? (
                  <span className="dv2-value">{dataBaixa ? formatDate(dataBaixa) : "—"}</span>
                ) : (
                  <input type="date" className="dv2-input" value={dataBaixa} onChange={(e) => setDataBaixa(e.target.value)} />
                ),
                "curt"
              )}
            {potGestionarHorari &&
              camp(
                "Horari",
                false,
                isReadOnly ? (
                  <span className="dv2-value">
                    {horariResum === null
                      ? "Carregant…"
                      : horariResumError
                      ? "No s'ha pogut carregar l'horari."
                      : !horariResum || horariResum.length === 0
                      ? "No hi ha horari assignat."
                      : "Horari assignat. Obre Gestió per consultar-lo o modificar-lo."}
                  </span>
                ) : (
                  <span className="dv2-value">
                    {empleat?.idEmpleats ? "Consulta o modifica l'horari a Gestió." : "Disponible després de crear l'empleat."}
                  </span>
                ),
                "llarg"
              )}
          </div>
        </section>
      </>
    );
  };

  return (
<>

{showDeleteModal && (
        <div
          className="dv2-modalOverlay"
          role="dialog"
          aria-modal="true"
          aria-labelledby="esborrar-empleat-title"
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) setShowDeleteModal(false);
          }}
        >
          <div className="dv2-modal">
            <h3 id="esborrar-empleat-title" className="dv2-modal-title">
              Confirmar esborrat
            </h3>
            <p className="dv2-modal-lead">Estàs segur que vols esborrar aquest empleat?</p>
            <div className="dv2-modal-actions">
              <button
                type="button"
                className="dv2-btn dv2-btn--danger"
                onClick={async () => {
                  try {
                    const response = await fetchAutenticat(
                      `${API_URL}/Esborrarempleat.php`,
                      {
                        method: "POST",
                        body: JSON.stringify({
                          idEmpleat: empleat.idEmpleats,
                          idEmpresa: empresaSeleccionada?.IdEmpresa,
                        }),
                      }
                    );
                    const data = await response.json();
                    if (data.success) {
                      alert("Empleat esborrat correctament!");
                      setShowDeleteModal(false);
                      onDeleted?.();
                      if (!onDeleted) onCancel();
                    } else {
                      alert(`Error en esborrar el empleat: ${data.message}`);
                      setShowDeleteModal(false);
                    }
                  } catch (error) {
                    if (!(error instanceof SessioCaducadaError)) {
                      console.error("Error en esborrar el empleat:", error);
                      alert("S'ha produït un error.");
                    }
                    setShowDeleteModal(false);
                  }
                }}
              >
                Esborrar
              </button>
              <button
                type="button"
                className="dv2-btn"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel·lar
              </button>
            </div>
          </div>
        </div>
      )}

{showModal && (
        <div
          className="dv2-modalOverlay"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-title"
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) setShowModal(false);
          }}
        >
          <div className="dv2-modal">
            <h3 id="modal-title" className="dv2-modal-title">
              {isModification ? "Modifica professió" : "Nova professió"}
            </h3>
            <p className="dv2-modal-lead">
              {isModification
                ? "El nou nom s'aplicarà a tots els registres que el fan servir."
                : "La deixarem seleccionada en aquest empleat."}
            </p>
            <label className="dv2-field">
              <span className="dv2-label dv2-required">Nom</span>
              <input
                type="text"
                className="dv2-input"
                maxLength={100}
                autoFocus
                value={newDescription}
                onChange={(e) => setNewDescription(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSaveModal();
                  }
                }}
                placeholder="Ex. Electricista"
              />
            </label>
            <div className="dv2-modal-actions">
              <button type="button" className="dv2-btn" onClick={() => setShowModal(false)}>
                Cancel·lar
              </button>
              <button type="button" className="dv2-btn dv2-btn--primary" onClick={handleSaveModal}>
                {isModification ? "Desar" : "Crear"}
              </button>
            </div>
          </div>
        </div>
      )}

    <form className="dv2-entity" onSubmit={(e) => e.preventDefault()}>
      {mostraAjuda && <AjudaEntitats pestanya="empleatFitxa" onTancar={() => setMostraAjuda(false)} />}
      <div className="dv2-pageHeader">
        <div className="dv2-pageHeader-main">
          <div className={`dv2-pageHeader-icon ${mode === "esborrar" ? "is-danger" : ""}`} aria-hidden="true">
            {mode === "esborrar" ? "🗑️" : "👷"}
          </div>
          <div>
            <h1 className="dv2-pageHeader-title">
              {mode === "nou"
                ? "Nou empleat"
                : mode === "esborrar"
                ? "Esborrar empleat"
                : mode === "modificar"
                ? "Modificar empleat"
                : "Empleats · Fitxa"}
            </h1>
            <p className="dv2-pageHeader-subtitle">
              {mode === "nou"
                ? "Omple la fitxa de l'empleat."
                : mode === "esborrar"
                ? "Aquesta acció no es pot desfer."
                : [[cognom1, cognom2].filter((x) => x && String(x).trim()).join(" "), nom]
                    .filter((x) => x && String(x).trim())
                    .join(", ") || "Dades de l'empleat"}
            </p>
          </div>
        </div>
        <div className="dv2-pageHeader-actions">
          <BotoAjuda title="Com funciona la fitxa de l'Empleat" onClick={() => setMostraAjuda(true)} />
          <button type="button" className="dv2-btn" onClick={onCancel}>
            Tornar
          </button>
          {mode === "consultar" && pucModificar && (
            <button type="button" className="dv2-btn dv2-btn--primary" onClick={() => onCanviarMode?.("modificar")}>
              Modificar
            </button>
          )}
          {mode === "consultar" && (
            <div style={{ position: "relative" }}>
              <button type="button" className="dv2-btn" onClick={() => setMenuAccions((v) => !v)}>
                Més accions
              </button>
              {menuAccions && (
                <div className="dv2-menu" style={{ right: 0, top: "42px" }}>
                  {pucGestio && (
                    <button
                      type="button"
                      className="dv2-menu-item"
                      onClick={() => {
                        setMenuAccions(false);
                        onCanviarMode?.("gestio");
                      }}
                    >
                      Gestió
                    </button>
                  )}
                  {pucEsborrarFitxa && (
                    <button
                      type="button"
                      className="dv2-menu-item is-danger"
                      onClick={() => {
                        setMenuAccions(false);
                        onCanviarMode?.("esborrar");
                      }}
                    >
                      Esborrar
                    </button>
                  )}
                </div>
              )}
            </div>
          )}
          {(mode === "nou" || mode === "modificar") && (
            <button type="button" className="dv2-btn dv2-btn--primary" onClick={handleSubmit}>
              Desar
            </button>
          )}
          {mode === "esborrar" && (
            <button type="button" className="dv2-btn dv2-btn--danger" onClick={handleSubmit}>
              Esborrar empleat
            </button>
          )}
        </div>
      </div>
      {subnav}
      {mode === "esborrar" && (
        <div className="dv2-banner dv2-banner--danger">
          Aquesta acció no es pot desfer. Si l'empleat té historial laboral, el servidor pot no deixar-lo esborrar.
        </div>
      )}
      <div className="dv2-entity-body">
        {renderCamps()}
      </div>
      {((["consultar", "modificar"].includes(mode) && empleats && empleats.length > 1 && currentIndex >= 0) ||
        mode === "nou" ||
        mode === "modificar" ||
        mode === "esborrar") && (
        <div className="dv2-entity-dock">
          {["consultar", "modificar"].includes(mode) && empleats && empleats.length > 1 && currentIndex >= 0 && (
            <div className="dv2-recordNav">
              <button type="button" className="dv2-btn dv2-recordNav-btn" onClick={anteriorEmpleat} title="Anterior">
                ‹
              </button>
              <span className="dv2-recordNav-info">
                {currentIndex + 1} / {empleats.length}
              </span>
              <button type="button" className="dv2-btn dv2-recordNav-btn" onClick={seguentEmpleat} title="Següent">
                ›
              </button>
            </div>
          )}
          {(mode === "nou" || mode === "modificar" || mode === "esborrar") && (
            <div className="dv2-footerActions">
              <button type="button" className="dv2-btn" onClick={onCancel}>
                Cancel·lar
              </button>
              {mode === "esborrar" ? (
                <button type="button" className="dv2-btn dv2-btn--danger" onClick={handleSubmit}>
                  Esborrar empleat
                </button>
              ) : (
                <button type="button" className="dv2-btn dv2-btn--primary" onClick={handleSubmit}>
                  {mode === "nou" ? "Desar empleat" : "Desar"}
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </form>
    </>
  );
}

export default DetallsEmpleat;
